import { DashboardModule } from '@domain-group/suit-theme'
import useCurrentUser from '@hooks/useCurrentUser'

import useInvoice from '@hooks/useInvoice'

import LinkedBooking from './LinkedBooking'
import LinkedCampaign from './LinkedCampaign'
import LinkedPackage from './LinkedPackage'
import LinkedStaff from './LinkedStaff'

type InvoicePayloadProps = {
  invoicePayload: ReturnType<typeof useInvoice>,
}

const LinkedEntities = (props: InvoicePayloadProps) => {
  const { invoicePayload } = props

  const {
    booking, campaign, hasLinkedEntities, hasUsers, providerPackage,
  } = invoicePayload

  const currentUserPayload = useCurrentUser()

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Linked Entities"
    >
      {campaign?.id && <LinkedCampaign invoicePayload={invoicePayload} />}

      {booking?.id && <LinkedBooking booking={booking} currentUserPayload={currentUserPayload} />}

      {providerPackage?.id && <LinkedPackage providerPackage={providerPackage} />}

      {hasUsers && <LinkedStaff invoicePayload={invoicePayload} />}

      {!hasLinkedEntities && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Linked Entities present
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}
    </DashboardModule>
  )
}
export default LinkedEntities
